module.exports = {
  dateComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    { label: "Between", value: "between" }
  ],
  numberComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    // { label: "Is Empty", value: "is-empty" },
    // { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Less Than", value: "less-than" },
    { label: "Greater Than", value: "greater-than" },
    { label: "Less Than or Equal", value: "less-than-or-equal" },
    { label: "Greater Than or Equal", value: "greater-than-or-equal" }
  ],
  stringComponent: [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Starts With", value: "starts-with" },
    { label: "Ends With", value: "ends-with" },
    { label: "Like", value: "like" },
    { label: "Not Contains", value: "not-contains" },
    { label: "Contains", value: "contains" },
  ],
  //deal options
  dealSourceOptions: [
    { value: '', label: '-None-' },
    { value: 'Tele Sales (Self Sourcing)', label: 'Tele Sales (Self Sourcing)' },
    { value: 'Sales Person Office Data', label: 'Sales Person Office Data' },
    { value: 'Website', label: 'Website' },
    { value: 'Social Media', label: 'Social Media' },
    { value: 'Referral', label: 'Referral' },

    { value: 'Campaign', label: 'Campaign' },
    // { value: 'Facebook', label: 'Facebook' },
    // { value: 'Trade Show', label: 'Trade Show' },
    { value: 'Cold Call ', label: ' Cold Call' },
    { value: 'Campaign', label: 'Campaign' },
    // { value: 'Chatbot', label: 'Chatbot' },
    { value: 'Old Firm Data', label: 'Old Firm Data' },
    { value: 'Door to Door', label: 'Door to Door' },
  ],
  dealStageOptions: [
    { label: "Proposal Sent", value: "Proposal Sent" },
    { label: "Negotiation", value: "Negotiation" },
    { label: "Won", value: "Won" },
    { label: "Lost", value: "Lost" },
  ],
  statusOptions: [
    {
      value: "Open",
      label: "🔵 Open",
      color: "darkblue",
      backgroundcolor: "#D0E2FF",
    },
    {
      value: "Working-on-it",
      label: "🟡 Working on it",
      color: "#8B8000",
      backgroundcolor: "#FFECB3",
    },
    {
      value: "Ready-for-Review",
      label: "🟣Ready for Review",
      color: "indigo",
      backgroundcolor: "#E1BEE7",
    },
    {
      value: "Closed",
      label: "🟢 Closed",
      color: "darkgreen",
      backgroundcolor: "#C8E6C9",
    },
    {
      value: "On-Hold",
      label: "🔴 On Hold",
      backgroundcolor: "#ffdbdb ",
      color: "red",
    },
  ],
  priorityOptions: [
    {
      value: "High",
      label: "🔴 High",
      color: "white",
      backgroundColor: "#ff4d4d", // Fix key: Use backgroundColor
    },
    {
      value: "Medium",
      label: "🟠 Medium",
      color: "black",
      backgroundColor: "#ffcc80",
    },
    {
      value: "Low",
      label: "🟢 Low",
      color: "black",
      backgroundColor: "#a5d6a7",
    },
  ]


}  